import type { Field } from '@sevenrooms/form'
import { useLocales } from '@sevenrooms/locales'
import { FormInput, Label } from '@sevenrooms/ui-kit/form'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

export interface EmailAddressFormProps {
  disabled: boolean
  emailAddressField: Field<string>
  hideAsterisk?: boolean
}

export function EmailAddressForm({ disabled, emailAddressField, hideAsterisk = false }: EmailAddressFormProps) {
  const { formatMessage } = useLocales()

  const emailMessage = formatMessage(reservationWidgetMessages.resWidgetEmailLabel)

  return (
    <Label primary={`${emailMessage}${hideAsterisk ? '' : '*'}`}>
      <FormInput
        aria-required="true"
        autoComplete="email"
        data-test="sr-reservation-email-address"
        disabled={disabled}
        field={emailAddressField}
        fullWidth
        placeholder={emailMessage}
        type="email"
      />
    </Label>
  )
}
